import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import RTL from "./RTL";
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Label from './Label'
import Success from './Success'
import SuccessSms from './SuccessSms'
import LocalQR from './LocalQR'
import Failed from './Failed'
import Welcome from './Welcome'
import * as serviceWorker from './serviceWorker';




// cookies.remove('login_user')
// var Router = require('react-router');
ReactDOM.render(
  <RTL>
  <React.StrictMode>
    <BrowserRouter>
      <Switch>
        <Route path="/success" component={Success} />
        <Route path="/invited" component={SuccessSms} />
        <Route path="/failed" component={Failed} />
        <Route path="/localQR" component={LocalQR} />
        <Route path="/welcome" component={Welcome} />
        <Route path="/" component={Label} />
      </Switch>
    </BrowserRouter>
  </React.StrictMode>
  </RTL>,
  document.getElementById('root')
  
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
